import { api } from "../api";

const URL = "/v2/program-runs";

export const programRunsApi = api.injectEndpoints({
    endpoints: builder => ({
        getProgramRuns: builder.query<any[], { program_id: string }>({
            query: ({ program_id }) => ({
                url: `${URL}?program_id=${program_id}`,
                method: "get"
            }),
            transformResponse: (response: any) => response.data,
            providesTags: ["ProgramRuns"]
        }),
        createProgramRun: builder.mutation<any, any>({
            query: (data) => ({
                url: `${URL}/create`,
                method: "post",
                data
            }),
            invalidatesTags: ["ProgramRuns"]
        })
    })
});

export const {
    useGetProgramRunsQuery,
    useCreateProgramRunMutation
} = programRunsApi;
